import WaveSurfer from 'wavesurfer.js';
import RecordPlugin from 'wavesurfer.js/dist/plugins/record';
import React, { useEffect, useRef } from 'react';
import { formatTime } from 'util/helper';

const MicWaveform = ({ progressValue, mockColor = "#008000",time=-1 }) => {
  const progressRangeRef = useRef({ start: null, end: 100 });
  const waveformRef = useRef(null);
  const wavesurferRef = useRef(null);
  const cursorRef = useRef(null);
  const isStopped = useRef(false); // track if mic is already stopped
  const isStarted = useRef(false);

  useEffect(() => {
    if (!waveformRef.current) return;

    wavesurferRef.current = WaveSurfer.create({
      container: waveformRef.current,
      waveColor: mockColor ? mockColor : '#008000',
      interact: false,
      cursorWidth: 1,
      height: 100,
      plugins: [
        RecordPlugin.create({
          scrollingWaveform: true,
          renderRecordedAudio: false,
        }),
      ],
    });

    // const recordPlugin = wavesurferRef.current.plugins[0];
    // recordPlugin.startRecording();

    return () => {
      // const recordPlugin = wavesurferRef.current?.plugins?.[0];
      // recordPlugin && recordPlugin.stopRecording();
      // wavesurferRef.current.destroy();
    };
  }, []);

  // Handle Progress and Mic Start
  useEffect(() => {
    const recordPlugin = wavesurferRef.current?.plugins?.[0];
    const cursor = cursorRef.current;
    const waveform = waveformRef.current;


    if (progressValue > 0 && recordPlugin && !isStarted.current) {
      recordPlugin.startRecording();
      isStarted.current = true;
      progressRangeRef.current.start = progressValue; 
    }
    if (cursor && waveform) {
      if (!isStarted.current) {
        cursor.style.display = 'none';
      }
      else {
         
        const totalWidth = waveformRef?.current?.clientWidth;
        const { start, end } = progressRangeRef.current;
        // const progress = Math.min(progressValue / 100, 1);  //work until 100% progress value
        const normalizedProgress = (progressValue - start) / (end - start);
        const progress = Math.min(Math.max(normalizedProgress, 0), 1);
        cursor.style.left = `${progress * totalWidth}px`; // Move cursor

        if (progress >= 1 && recordPlugin && !isStopped.current) {
          recordPlugin.stopRecording();
          isStopped.current = true;
        }
        cursor.style.display = 'block';
      }
    }
  }, [progressValue]);
  
  return (
    <>
    <div className="mic-waveform-container">
      <div ref={waveformRef} id="waveform" className="mic-waveform-wave" />
      <div ref={cursorRef} className="mic-waveform-cursor" />
    </div>
      {
        time >= 0 ? 
        <div className="mic-waveform-time text-secondary px-3" style={{marginTop: '26px'}}>{formatTime(time)}</div>
        : null
      }
    </>
  );
};

export default MicWaveform;
